export default __webpack_public_path__ + "static/media/EmptyCircleTick.0288fd07.svg";